<template>
	<div>
		<!-- <Nav :title="xgTheme.loginTitle" :back="false" /> -->
		</Nav>
		<UserInfo :count="count"></UserInfo>
		<Product v-show="!showTwiceCodeModel" @changePrice="changePrice" @changeProduct="changeProduct"></Product>
		<div class="empty-div"></div>
		<div class="pay-div flex">
			<div class="pay-count">
				<span class="f-s-14 black">合计</span>
				<span class="pink f-s-18 m-l-5 w-550">{{totalPonits|toCmssScore}}积分</span>
				<span class="f-s-14 m-l-5">(={{totalPonits}}畅由积分)</span>
			</div>
			<div class="pay-btn">
				<van-button round type="info" @click="willConversion" :disabled="totalPonits<=0">立即兑换</van-button>
			</div>
		</div>

		<van-popup v-model="showIntegralLimitModel" closeable round :close-on-click-overlay="false">
			<IntegralLimit></IntegralLimit>
		</van-popup>

		<div class="step-div">
			<van-popup v-model="showTwiceCodeModel" :close-on-click-overlay="false">
				<div class="popup-close-div">
					<van-icon name="close" @click="showTwiceCodeModel = false" color="#ffffff" />
				</div>
				<TwiceCode :order="order" :smsStatus="smsStatus" @payErrorPoss="payErrorPoss"></TwiceCode>
			</van-popup>
		</div>

		<van-popup v-model="showOnceCodeModel" round :close-on-click-overlay="false" closeable>
			<OnceCode :order="order" :smsStatus="paySendStatus" @payErrorPoss="payErrorPoss"></OnceCode>
		</van-popup>
	</div>
</template>



<script>
	import Nav from '../components/common/Nav.vue'
	import UserInfo from '../components/home/UserInfo.vue'
	import Product from '../components/home/Product.vue'
	import IntegralLimit from '../components/home/IntegralLimit.vue'
	import TwiceCode from '../components/home/TwiceCode.vue'
	import OnceCode from '../components/home/OnceCode.vue'
	import {
		Toast
	} from 'vant';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	import {
		createOrder
	} from '@/request/api'
	export default {
		name: 'Home',
		computed: mapGetters(['xgUserInfo','xgTheme']),
		components: {
			[Nav.name]: Nav,
			[UserInfo.name]: UserInfo,
			[Product.name]: Product,
			[IntegralLimit.name]: IntegralLimit,
			[TwiceCode.name]: TwiceCode,
			[OnceCode.name]: OnceCode
		},

		data() {
			return {
				count: 0,
				order: {},
				smsStatus: 0,
				paySendStatus: 0,
				isUpLimit: 0,
				totalPonits: 0,
				selectedProduct: [],
				showIntegralLimitModel: false,
				showTwiceCodeModel: false,
				showOnceCodeModel: false


			}
		},

		methods: {
			payErrorPoss() {

				this.showTwiceCodeModel = false
				this.showOnceCodeModel = false
				Toast.fail('支付失败，请重试！')
			},
			changePrice(totalPonits) {
				this.totalPonits = totalPonits
			},
			changeProduct(selectedProduct) {
				this.selectedProduct = selectedProduct
			},
			conversion() {
				if (this.isUpLimit == 1) {
					this.showIntegralLimitModel = true
					return
				}
				if (this.xgUserInfo.isImpower != 1) {
					// Toast.fail('请先进行授权！');
					this.count++
					return
				}
				if (this.totalPonits <= 0) {
					Toast.fail('请选购产品！');
					return
				}
				//创建订单
				this.createOrder()

			},
			willConversion() {
				if (this.timeout) {
					clearTimeout(this.timeout)
				}
				this.timeout = setTimeout(() => {
					this.conversion();
				}, 500);
			},
			createOrder() {
				if (this.xgUserInfo.cyScore < this.totalPonits && Math.floor(this.xgUserInfo.cmccScore / 120) * 100 < this.totalPonits) {
					Toast.fail('积分不足！');
					return
				}
				createOrder({
					mobile: this.xgUserInfo.mobile,
					scoreProducts: this.selectedProduct
				}).then(res => {
					//积分上限判断完了
					if (res.isUpLimit == 1) {
						this.isUpLimit = res.isUpLimit
						this.showIntegralLimitModel = true
						return
					}
					this.smsStatus = res.smsStatus;
					this.paySendStatus = res.paySendStatus;
					this.order.reserved1 = this.selectedProduct[0].reserved1
					this.order.reserved2 =  this.selectedProduct[0].reserved2
					this.order.scoreOrderId = res.scoreOrderId
					this.order.price = res.price
					this.order.cyScore = this.totalPonits
					//判断需要多少次验证
					if (this.xgUserInfo.cyScore >= this.totalPonits) {
						this.showOnceCodeModel = true
					} else {
						//计算所需移动积分
						let totalCmssScore = Math.ceil(this.totalPonits * 1.2)
						let resultCmssScore = Math.ceil(totalCmssScore / 120) * 120
						this.order.toCyScore = Math.ceil(totalCmssScore / 120) * 100
						this.order.cmssScore = resultCmssScore
						this.showTwiceCodeModel = true
					}
				})
			}

		}
	}
</script>

<style scoped>
	.empty-div {
		height: 90px;
		width: 100%;
	}

	.pay-div {
		height: 76px;
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		background-color: #ffffff;
	}

	.pay-count {
		flex: 1;
		padding: 25px 0 0 20px;
		font-weight: 500;
	}

	.pay-btn {
		width: max-content;
		padding: 15px 10px 0 0
	}

	.pay-btn /deep/ .van-button {
		background-color: #2e2c29;
		border-color: #2e2c29;
		font-weight: 550;
	}



	.popup-close-div {
		width: 20px;
		height: 20px;
		background-color: #000000;
		top: 4px;
		right: 0px;
		position: absolute;
		z-index: 10000;
	}

	.popup-close-div>.van-icon {
		font-size: 20px;
	}

	.step-div /deep/ .van-popup {
		background-color: unset;
	}
</style>
